import { Observable } from 'rxjs';

export function getBase64$(file: File): Observable<ProgressEvent<FileReader>> {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  return new Observable((observer) => {
    reader.onload = (e: ProgressEvent<FileReader>) => {
      observer.next(e);
      observer.complete();
    };
    reader.onerror = (error: ProgressEvent<FileReader>) => {
      observer.next(error);
    };
  });
}
